import React, { useState, useEffect, useRef } from 'react';
import { Form, Button, InputGroup, Modal, Spinner } from 'react-bootstrap';
import config from 'react-global-configuration';
import axios from 'axios';
import toastr from "toastr";

import HeaderComponent from '../../components/header';
import MapComponent from '../../components/mapConponent';
import Details from './modal-details';
import ModalReport from './report/report';
import ModalCadastro from '../cadastroPropriedades/modalCadastro';

function Geo() {

    const [show, setShow] = useState(false);
    const [showReport, setShowReport] = useState(false);
    const [simpleReport, setSimpleReport] = useState(false);
    const [showReportSuccess, setShowReportSuccess] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [polygons, setPolygons] = useState([]);
    const [selectedPolygon, setSelectedPolygon] = useState(null);
    const [data, setData] = useState({});
    const [checked, setChecked] = useState([]);
    const [checkedPolygons, setCheckedPolygons] = useState([]);
    const [searchContent, setSearchContent] = useState('');
    const [load, setLoad] = useState(false);
    const [hasNext, setHasNext] = useState(false);
    const [initialData, setInitialData] = useState(null);
    const [updateList, setUpdateList] = useState([]);
    const [totalPaginas, setTotalPaginas] = useState(0);
    const [deleteEnable, setDeleteEnable] = useState(false);
    const [kmlData, setKmlData] = useState([]);
    const itensPorPagina = 10;

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleCloseReport = () => { setShowReport(false); setSimpleReport(false); setShowReportSuccess(false); setChecked([]) };
    const handleCloseEdit = () => setShowEdit(false);
    const handleShowReport = () => setShowReport(true);
    const handleShowEdit = (data) => {
        setShowEdit(true);
        setInitialData(data);
    };

    const [page, setPage] = useState(1);

    const indiceUltimoItem = page * itensPorPagina;
    const indicePrimeiroItem = indiceUltimoItem - itensPorPagina;

    const apiKey = config.get('apiKeyGm');

    useEffect(() => {
        // Função para carregar os arquivos KML do S3
        const loadKMLFromS3 = async () => {
            setLoad(true);
            // const s3 = new AWS.S3({
            //     accessKeyId: config.get('s3.accessKeyId'),
            //     secretAccessKey: config.get('s3.secretAccessKey'),
            //     region: config.get('s3.region')
            // });

            const param = searchContent !== '' ? '&content=' + searchContent : '';
            try {
                const url = config.get('urlbase') + '/imoveis/list-imoveis?status_imovel=enable&contract_id=' + JSON.parse(localStorage.getItem('userInfos')).data.contract_id + '&customercnpj=' + JSON.parse(localStorage.getItem('userInfos')).data.customercnpj;
                // const url = config.get('urlbaseLocal') + '/imoveis?page=' + page + param;
                const headers = { 'x-api-key': JSON.parse(localStorage.getItem('userInfos')).data.Token, 'Content-Type': 'application/json' };
    
                const kmlFiles = (await axios.get(url, { headers })).data.Item;
                setPolygons(kmlFiles.Properties);

                let downArray = [...kmlFiles.Properties];

                downloadKMLFiles(downArray.slice(0, itensPorPagina));

                const totalPages = Math.ceil(kmlFiles.Properties.length / itensPorPagina);
                // setHasNext(kmlFiles.data.hasNext);
                if (page < totalPages) {
                    setHasNext(true);
                } else {
                    setHasNext(false);
                }
                setTotalPaginas(totalPages);
                setLoad(false);
                setTimeout(() => {
                    //document.querySelector('.list-marks li:first-child').click();
                }, 3000);
    
    
                console.log(polygons);
                
            } catch (error) {
                console.error('Erro ao obter dados');
                setLoad(false);
            }

            
        };

        loadKMLFromS3();
    }, [updateList]);

    useEffect(() => {
        document.body.className = '';
    }, []);


    const handleUpdateList = (data) => {
        setUpdateList((prev) => ([...prev, data]));
        setShowEdit(false);
        setDeleteEnable(false);
        // handlePolygonClick(selectedPolygon);
    }

    const handlePolygonClick = async (polygonIndex) => {
        console.log(`Clicou no polígono ${polygonIndex}`, polygons[polygonIndex]);
        const polygonData = polygons.filter((item) => item.imovel_id === polygons[polygonIndex].imovel_id);
        try {
            const url = config.get('urlbase') + '/imoveis/get-imovel?contract_id=' + JSON.parse(localStorage.getItem('userInfos')).data.contract_id + '&customercnpj=' + JSON.parse(localStorage.getItem('userInfos')).data.customercnpj + '&imovel_id=' + polygonData[0].imovel_id;
            const headers = { 'x-api-key': JSON.parse(localStorage.getItem('userInfos')).data.Token, 'Content-Type': 'application/json' };

            const response = (await axios.get(url, { headers })).data;
            setData(response.Item);
            console.log(data);
            handleShow();
            setSimpleReport(true);
            setSelectedPolygon(polygonIndex);
        } catch (error) {
            toastr.error('Erro ao recuperar os dados da propriedade');
        }

        console.log(selectedPolygon);
    };

    const handleSearchClick = (e) => {
        e.preventDefault();
        setTimeout(() => {
            if (searchContent === '') {
                setPage(1);
            }
        }, 1000);
        setSearchContent(document.getElementById('searchContent').value);
        return;
    }

    const filteredPolygons = polygons.filter((polygon) =>
        polygon.title.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase().includes(searchContent.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase())
    ).slice(0, indiceUltimoItem);

    useEffect(() => {
        if (page < totalPaginas) {
            if (filteredPolygons.length > itensPorPagina){
                downloadKMLFiles(filteredPolygons.slice(indicePrimeiroItem, indiceUltimoItem));
            }
        }
    }, [page]);

    useEffect(() => {
        if (page < totalPaginas) {
            setHasNext(true);
        } else {
            setHasNext(false);
        }
    }, [page, filteredPolygons, searchContent]);

    const handleLinkClick = (e, polygonIndex) => {
        e.preventDefault();
        console.log(`Clicou no link para o polígono ${polygonIndex}`);
        setSelectedPolygon(polygonIndex);
    };

    const handleRequestReport = async () => {
        if (checked && checked.length > 0) {
            try {
                const url = config.get('urlbaseMock') + '/requestreport';
                const headers = { 'x-api-key': JSON.parse(localStorage.getItem('userInfos')).data.Token, 'Content-Type': 'application/json' };
                const params = checked;
                const response = await axios.post(url, JSON.stringify(params), { headers: headers });
                setShowReportSuccess(true);
                setChecked([]);
            } catch (error) {
                toastr.error('Erro ao solicitar o relatório');
            }
        } else {
            toastr.warning('Escolha um item para gerar o relatório');
        }
    }
    const kmlDataArray = [];

    const downloadKMLFiles = async (params) => {
            
        for (const kmlFile of params) {
            const params = {
                Bucket: config.get('s3.bucketKML'),
                Key: kmlFile.kml,
            };

            try {
                const urlDownload = config.get('urlbase') + '/imoveis/download-file?contract_id=' + JSON.parse(localStorage.getItem('userInfos')).data.contract_id + '&customercnpj=' + JSON.parse(localStorage.getItem('userInfos')).data.customercnpj + '&imovel_id=' + kmlFile.imovel_id + '&filename=' + params.Key
                const headers = { 'x-api-key': JSON.parse(localStorage.getItem('userInfos')).data.Token, 'Content-Type': 'application/json' };

                (axios.get(urlDownload, { headers })).then((item) => {
                    setTimeout(() => {
                        setKmlData((prev) => ([...prev, { url: item.data.Item.Url, ...kmlFile }]));
                    }, 3000);
                });
                //kmlDataArray.push({ url: kmlUrl.Url, ...kmlFile });

                console.log(kmlDataArray);
            } catch (error) {
                console.error('Erro ao obter o arquivo');
                setLoad(false);
            }
            
        }
        // setKmlData((prev) => ([...prev, kmlDataArray[0]]));
        // setKmlData(kmlDataArray);
    }

    const childRef = useRef();

    const handleSaveInfos = async () => {
        childRef.current.handleSave();
    }

    const handleShowMore = () => {
        if (page < totalPaginas) {
            let count = page;
            count++;
            setPage(count);
            setHasNext(true);
        } else {
            setHasNext(false);
        }
    }

    const handleDeactive = async (polygonIndex) => {
        const polygonData = polygons.filter((item) => item.imovel_id === polygons[polygonIndex].imovel_id);
        try {
            const url = config.get('urlbase') + '/imoveis/update-active';
            const headers = { 'x-api-key': JSON.parse(localStorage.getItem('userInfos')).data.Token, 'Content-Type': 'application/json' };
            const params = {
                customercnpj: JSON.parse(localStorage.getItem('userInfos')).data.customercnpj,
                contract_id: JSON.parse(localStorage.getItem('userInfos')).data.contract_id,
                imovel_id: polygonData[0].imovel_id,
                active: false
            };
            const response = (await axios.post(url, JSON.stringify(params), { headers })).data;
            toastr.success('Propriedade desativada com sucesso');
        } catch (error) {
            toastr.error('Erro ao remover propriedade');
        }
        setUpdateList((prev) => ([...prev, polygonData[0].imovel_id]));
    }

    return (
        <>
            <HeaderComponent />
            <section id='panelMarkNavigate' className='panel-default mark-navigate'>
                <a href='javascript:void(0);' className='bt-mais' onClick={() => { handleShowEdit({}) }}>Adicionar nova propriedade <img src={process.env.PUBLIC_URL + '/static/imagens/bt-mais.png'} alt='Adicionar nova propriedade' /></a>
                <Form onSubmit={handleSearchClick}>
                    <InputGroup className="mb-3">
                        <Form.Control type='search' id='searchContent' placeholder="Buscar" aria-label="Buscar" aria-describedby="basic-addon2" />
                        <Button type='submit' variant="outline-secondary" id="button-addon2">
                            <i className="bi bi-search"></i>
                        </Button>
                    </InputGroup>
                </Form>
                {deleteEnable ? <a onClick={(e) => setDeleteEnable(false)} href='javascript:void(0);' style={{textDecoration: 'none', fontSize: '12px'}} className='link-danger mb-1 text-right display--block' title='Cancelar Remoção'><i className="bi bi-x-circle"></i> Cancelar Remoção</a> : <a onClick={(e) => setDeleteEnable(true)} href='javascript:void(0);' style={{textDecoration: 'none', fontSize: '12px'}} className='link-danger mb-1 text-right display--block color-tertiary' title='Deseja remover os imóveis da lista?'><i className="bi bi-trash"></i> Deseja remover os imóveis da lista?</a>}
                {!load ?
                    <ul className='list-marks scrollbar'>
                        {filteredPolygons && filteredPolygons.length > 0 ? filteredPolygons.map((kml, index) => (
                            <li key={index} onClick={(e) => handleLinkClick(e, index)} className={selectedPolygon && selectedPolygon === index ? 'active' : (!selectedPolygon && index === 0 ? 'active' : '')}>
                                <div><i className="bi bi-pin-map-fill pin--fill"></i><i className="bi bi-pin-map pin "></i></div>
                                <div style={{ width: "277px", lineHeight: 'normal' }}>
                                    <span title={kml.title} className='title'>{kml.title}</span>
                                    <small style={{ display: "inline" }}>{kml.coords}</small>
                                    {deleteEnable ? <><a onClick={(e) => handleDeactive(index)} href='' style={{textDecoration: 'none'}} className='link-danger' title='Remover Imóvel'><i className="bi bi-trash fs-6"></i></a></> : ''}
                                </div>
                                <div><i className="bi bi-arrow-right"></i></div>
                            </li>
                        )) : <li>Nenhum KML Cadastrado</li>}
                        {hasNext &&
                            <li style={{ borderBottom: 'none' }}>
                                <Button variant="light" type="button" size="sm" className='margin--auto display--block mt-3' onClick={(e) => { handleShowMore(e) }}>
                                    Mostrar Mais
                                </Button>
                            </li>}
                    </ul>
                    : <div className="list-marks scrollbar text-center">
                        <Spinner className='mt-5' animation="border" variant="success" />
                    </div>
                }
                <Button variant="info" type="button" className='margin--auto display--block mt-2' onClick={() => { handleShowReport(); setSimpleReport(false); }}>
                    <i className="bi bi-cloud-download-fill"></i>  Download de Relatórios
                </Button>
            </section>
            {/* {polygons.map((polygon, index) => (
                <button key={index} onClick={() => handleLinkClick(index)}>
                    Ir para Polígono {index}
                </button>
            ))} */}

            <MapComponent apiKey={apiKey} polygons={kmlData} onPolygonClick={handlePolygonClick} selectedPolygon={selectedPolygon}></MapComponent>

            <Modal show={show} onHide={handleClose} className='full' dialogClassName='modal-90'>
                <Modal.Header closeButton>
                    <Modal.Title>Detalhes da Propriedade</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Details propertie={data} onShowReport={handleShowReport} onShowEdit={handleShowEdit}></Details>
                </Modal.Body>
                <Modal.Footer>
                    <Button className='small' variant="secondary" onClick={(e) => handleClose(e)}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showReport} onHide={handleCloseReport} onShow={() => setShow(false)} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Download do Relatório</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    {/* <div>{`Items checked are: ${checked.toString()}`}</div> */}
                    {
                        !showReportSuccess ?

                            (simpleReport ? <ModalReport data={data} onPolygonsChecked={(items) => setCheckedPolygons(items)} onItemsChecked={(items) => setChecked(items)}></ModalReport> :
                                <ModalReport polygons={polygons} data={data} onPolygonsChecked={(items) => setCheckedPolygons(items)} onItemsChecked={(items) => setChecked(items)}></ModalReport>)
                            :
                            <>
                                <i className="bi bi-check-circle margin--auto text-center display--block color-primary" style={{ fontSize: "96px" }}></i>
                                <sapn className='margin--auto text-center display--block'><b>Estamos processando a sua solicitação.<br />Em breve o relatório será enviado para o seu e-mail</b></sapn>
                            </>
                    }

                </Modal.Body>
                <Modal.Footer>
                    <Button className='small' variant="secondary" onClick={(e) => { handleCloseReport(e); setShowReportSuccess(false) }}>
                        {!showReportSuccess ? 'Cancelar' : 'Fechar'}
                    </Button>
                    {!showReportSuccess ? <Button className='small' variant="primary" onClick={(e) => handleRequestReport(e)}>Gerar Relatório</Button> : ''}

                </Modal.Footer>
            </Modal>
            <Modal show={showEdit} onHide={handleCloseEdit} onShow={() => setShow(false)} className='full' dialogClassName='modal-90'>
                <Modal.Header closeButton>
                    <Modal.Title>Cadastro / Edição de Propriedade</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ModalCadastro ref={childRef} onUpdate={handleUpdateList} bindValues={initialData}></ModalCadastro>
                </Modal.Body>
                <Modal.Footer>
                    <Button className='small' variant="secondary" onClick={(e) => handleCloseEdit(e)}>
                        Cancelar
                    </Button>
                    <Button className='small' variant="primary" onClick={(e) => handleSaveInfos(e)}>
                        Salvar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default Geo;